import { scrollToTop } from '../../../utils/functions';

const MapPinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
);
const PhoneIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
);
const MailIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
    </svg>
);
const GlobeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
);
const FacebookIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
);
const ArrowUpIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/>
    </svg>
);
const SmallPhoneIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
);

const ShieldIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
);

const FileTextIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
);

const PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M8 5v14l11-7z"/>
    </svg>
);

const AddressBlock = ({ title, address, phone, mobile }) => (
    <div className="gmf-address-block gmf-card">
        <h4 className="gmf-address-title">{title}</h4>
        <p className="gmf-address-text">{address}</p>
        <div className="gmf-address-contacts">
            <p className="gmf-address-phone">
                <span className="gmf-address-phone-icon gmf-accent-color"><SmallPhoneIcon /></span>
                {phone}
            </p>
            {mobile && (
                <p className="gmf-address-phone">
                    <span className="gmf-address-phone-icon gmf-accent-color"><SmallPhoneIcon /></span>
                    {mobile}
                </p>
            )}
        </div>
    </div>
);

const Footer = ({ attributes, onNavigate }) => {
    const { footer } = attributes;

    const handleVideoPageClick = () => {
        if (onNavigate) {
            onNavigate('video-page');
            scrollToTop();
        }
    };

    const handlePrivacyPageClick = () => {
        if (footer.privacyUseExternalLink && footer.privacyExternalUrl) {
            window.open(footer.privacyExternalUrl, '_blank', 'noopener,noreferrer');
        } else if (onNavigate) {
            onNavigate('privacy-policy');
            scrollToTop();
        }
    };

    const handleTermsPageClick = () => {
        if (onNavigate) {
            onNavigate('terms-page');
            scrollToTop();
        }
    };

    return (
        <footer className="gmf-footer">
            <div className="gmf-footer-inner">
                <div className="gmf-footer-grid">

                    {/* Find Us */}
                    <div className="gmf-footer-find-us">
                        <h3 className="gmf-footer-heading">Find Us</h3>
                        <div className="gmf-address-grid">
                            <AddressBlock
                                title={footer.headOffice.title}
                                address={footer.headOffice.address}
                                phone={footer.headOffice.phone}
                                mobile={footer.headOffice.mobile}
                            />
                            <AddressBlock
                                title={footer.lalmatiaOffice.title}
                                address={footer.lalmatiaOffice.address}
                                phone={footer.lalmatiaOffice.phone}
                                mobile={footer.lalmatiaOffice.mobile}
                            />
                            <AddressBlock
                                title={footer.uttaraOffice.title}
                                address={footer.uttaraOffice.address}
                                phone={footer.uttaraOffice.phone}
                                mobile={footer.uttaraOffice.mobile}
                            />
                            {footer.extHeadOffice && footer.extHeadOffice.address && (
                                <AddressBlock
                                    title={footer.extHeadOffice.title}
                                    address={footer.extHeadOffice.address}
                                    phone={footer.extHeadOffice.phone}
                                    mobile={footer.extHeadOffice.mobile}
                                />
                            )}
                        </div>
                    </div>

                    {/* Video Page Button */}
                    <div className="gmf-footer-video">
                        <h3 className="gmf-footer-heading">{footer.videoButtonTitle || 'Media'}</h3>
                        <div className="gmf-footer-video-content">
                            <p className="gmf-footer-video-desc">{footer.videoButtonDesc || 'Watch our corporate videos and latest updates'}</p>
                            <button
                                className="gmf-footer-video-btn"
                                onClick={handleVideoPageClick}
                                style={{ backgroundColor: footer.videoButtonBgColor || '#ff0037' }}
                            >
                                {footer.videoButtonIcon ? (
                                    <img src={footer.videoButtonIcon} alt="" className="gmf-footer-video-btn-icon" />
                                ) : (
                                    <PlayIcon />
                                )}
                                <span>{footer.videoButtonText || 'Watch Video'}</span>
                            </button>
                        </div>

                        {/* Privacy Policy Button */}
                        <div className="gmf-footer-privacy" style={{ marginTop: '24px' }}>
                            <h3 className="gmf-footer-heading">{footer.privacyButtonTitle || 'Legal'}</h3>
                            <div className="gmf-footer-video-content">
                                <p className="gmf-footer-video-desc">{footer.privacyButtonDesc || 'Read our privacy policy and legal information'}</p>
                                {footer.privacyUseExternalLink && footer.privacyExternalUrl ? (
                                    <a
                                        href={footer.privacyExternalUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="gmf-footer-video-btn"
                                        style={{ backgroundColor: footer.privacyButtonBgColor || '#ff0037', textDecoration: 'none' }}
                                    >
                                        {footer.privacyButtonIcon ? (
                                            <img src={footer.privacyButtonIcon} alt="" className="gmf-footer-video-btn-icon" />
                                        ) : (
                                            <ShieldIcon />
                                        )}
                                        <span>{footer.privacyButtonText || 'Privacy Policy'}</span>
                                    </a>
                                ) : (
                                    <button
                                        className="gmf-footer-video-btn"
                                        onClick={handlePrivacyPageClick}
                                        style={{ backgroundColor: footer.privacyButtonBgColor || '#ff0037' }}
                                    >
                                        {footer.privacyButtonIcon ? (
                                            <img src={footer.privacyButtonIcon} alt="" className="gmf-footer-video-btn-icon" />
                                        ) : (
                                            <ShieldIcon />
                                        )}
                                        <span>{footer.privacyButtonText || 'Privacy Policy'}</span>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="gmf-footer-privacy" style={{ marginTop: '24px' }}>
                            <h3 className="gmf-footer-heading">{footer.termsButtonTitle || 'Terms & Conditions'}</h3>
                            <div className="gmf-footer-video-content">
                                <p className="gmf-footer-video-desc">{footer.termsButtonDesc || 'Read terms and conditions governing platform usage.'}</p>
                                <button
                                    className="gmf-footer-video-btn"
                                    onClick={handleTermsPageClick}
                                    style={{ backgroundColor: footer.termsButtonBgColor || '#ff0037' }}
                                >
                                    {footer.termsButtonIcon ? (
                                        <img src={footer.termsButtonIcon} alt="" className="gmf-footer-video-btn-icon" />
                                    ) : (
                                        <FileTextIcon />
                                    )}
                                    <span>{footer.termsButtonText || 'Terms & Conditions'}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Contact + Connect */}
                    <div className="gmf-footer-contact">
                        <div className="gmf-footer-contact-section">
                            <h3 className="gmf-footer-heading">Contact Us</h3>
                            <div className="gmf-contact-list">
                                <div className="gmf-contact-item">
                                    <span className="gmf-contact-icon"><MapPinIcon /></span>
                                    <span>{footer.contactAddress}</span>
                                </div>
                                <div className="gmf-contact-item">
                                    <span className="gmf-contact-icon"><PhoneIcon /></span>
                                    <span>{footer.contactPhone}</span>
                                </div>
                                <div className="gmf-contact-item">
                                    <span className="gmf-contact-icon"><MailIcon /></span>
                                    <span>{footer.contactEmail}</span>
                                </div>
                                <div className="gmf-contact-item">
                                    <span className="gmf-contact-icon"><GlobeIcon /></span>
                                    <span>{footer.contactWebsite}</span>
                                </div>
                            </div>
                        </div>

                        <div className="gmf-footer-connect-section">
                            <h3 className="gmf-footer-heading">Connect With Us</h3>
                            <a
                                href={footer.facebookUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="gmf-facebook-link"
                            >
                                <div className="gmf-facebook-icon-wrap">
                                    <FacebookIcon />
                                </div>
                                <span>Facebook</span>
                            </a>
                            {Array.isArray(footer.importantLinks) && footer.importantLinks.length > 0 && (
                                <>
                                    <h3 className="gmf-footer-heading" style={{ marginTop: '24px' }}>Important links</h3>
                                    <div className="gmf-contact-list">
                                        {footer.importantLinks.map((link) => (
                                            <a
                                                key={`${link.label}-${link.url}`}
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="gmf-contact-item"
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                            >
                                                <span className="gmf-contact-icon"><GlobeIcon /></span>
                                                <span>{link.label}</span>
                                            </a>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Bottom */}
                <div className="gmf-footer-bottom">
                    <p>{footer.copyrightText}</p>
                </div>
            </div>

            {/* Scroll to top */}
            <button className="gmf-scroll-top" onClick={scrollToTop} aria-label="Scroll to top">
                <ArrowUpIcon />
            </button>
        </footer>
    );
};

export default Footer;
